/* @flow */
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Button from 'components/Button.jsx';
import ActivityShareModal from './ActivityShareModal.jsx';
import Activity from 'entities/Activity';

import './styles/RecipientsNux.scss';

export default class RecipientsNux extends React.Component {
  static propTypes = {
    activity: React.PropTypes.instanceOf(Activity).isRequired,
  }

  render() {
    const { activity } = this.props;
    const shareModal = <ActivityShareModal activity={activity} />;
    const image = require(
      'assets/images/payments/CreateEventHovercard/create-event-introduction.svg'
    );
    const title = 'Let people know about your activity';
    const subtext = 'Share a link to your activity on Remind, ' +
                    'or send it to people via Facebook, Twitter, or email. 🎉';

    if (activity.isClosed()) {
      return (
        <TitleHeader
          className="RecipientsNux"
          image={image}
          title="This activity is closed"
          subtext="You have received no responses."
        />
      );
    }

    return (
      <TitleHeader
        className="RecipientsNux"
        image={image}
        title={title}
        subtext={subtext}>
        <ModalTrigger modal={shareModal}>
          <Button className="RecipientsNux-cta" eventElementName="RecipientsNux-cta">
            Share your activity
          </Button>
        </ModalTrigger>
      </TitleHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/RecipientsNux.jsx